import loadable from "@loadable/component";

export const ReferralPage = loadable(() => import("./ReferralPage"), {
  resolveComponent: mod => mod.ReferralPage,
});

export * from "./types";
